export enum INetworkDetailsPageTabs {
  Overview = 'overview',
  Subnets = 'subnets',
  Ports = 'ports',
}

export interface FixedIp {
  subnet_id: string
  ip_address: string
}

export interface BindingVifDetails {
  port_filter: boolean
  connectivity: string
  bridge_name: string
  datapath_type: string
}

export interface DnsAssignment {
  ip_address: string
  hostname: string
  fqdn: string
}

export interface Port {
  id: string
  name: string
  network_id: string
  tenant_id: string
  mac_address: string
  admin_state_up: boolean
  status: string
  device_id: string
  device_owner: string
  fixed_ips: FixedIp[]
  allowed_address_pairs: any[] // If needed, define properly later
  extra_dhcp_opts: any[] // Can also be typed
  security_groups: string[]
  description: string
  'binding:vnic_type': string
  'binding:profile': Record<string, unknown>
  'binding:host_id': string
  'binding:vif_type': string
  'binding:vif_details': BindingVifDetails
  port_security_enabled: boolean
  qos_policy_id: string | null
  qos_network_policy_id: string | null
  dns_name: string
  dns_assignment: DnsAssignment[]
  dns_domain: string
  resource_request: any | null // Depending on usage
  tags: string[]
  created_at: string
  updated_at: string
  revision_number: number
  project_id: string
}
